export default __webpack_public_path__ + "static/media/Dreamer's Keepsake.4192bac3.jpg";